export class Constants {
  // parameterTypeId
  //public HRMSUrl ="http://localhost:4200/login?id="
  public enumParamterTypeName: any;
  public enumAttendanceStatus: any;
  public enumUserStatus: any;
  public enumCustomerStatus: any;
  public enumProjectStatus: any;
  public enumFeeType: any;

  public enumSiteUserStatus: any = [];
  public showLoader = false;
  public globalError = "error|Error Occured,Please Contact Administrator";
  public userInactiveError =
    "error|Your Account is InActive,Please Contact Administrator";
  public enumIssueStage: any;
  public SessionTimeOut: number = 30;
  public enumReviewEmployeeStatus: any;
  public enumUserRole: any;
  dataInputFileTypeId: any;
  messageId: any;
  uploadStatus: any;
  taskStatus: any;
  IRStatus: any;
  projectType: any;
  FileType: any;
  PrjectStage: any;
  PwerBiMenu: any;
  InstallationType: any;
  UserType: any;
  AttachmentsPath: any;

  public numberOnlyPattern: RegExp = /^[0-9.]*$/i;
  public isEmqube = false;
  public TeamId: string =  this.isEmqube ? "1,2,3,4" :"1,2,3,4,11,13,14,15,16,17,18,1018,1019,1020,1021,1022,1023,1024,1025,2026,2028,2029,2030"; // for swan
  // public TeamId: string = "1,2,3,4";   // for Emqube

  constructor() {
    this.enumParamterTypeName = {
      Country: 1,
      ProjectType: 3,
      ServiceType: 4,
      ProjectStage: 5,
      Currency: 9,
      StatusID: 11,
      UserStatus: 12,
      CityId: 14,
      StateId: 15,
      ProjectStatus: 18,
      Grade: 20,
      VendorGrade: 24,
      OrganizationStatus: 23,
      PaymentMode: 16,
      FeeType: 25,
      UserType: 17,
      PointType: 22,
      IssueSeverity: 23,
      IssuePriority: 24,
      IssueStatus: 25,
      IssueCategory: 26,
      DateRange: 27,
      IssueStage: 28,
      ReviewStageType: 29,
      ServiceRequestStatusType: 30,
      TaskStatus: 33,
      TaskStatusType: 32,
      InstallationType: 43,
      IRStatus: 45,
    };
    this.enumAttendanceStatus = {
      Absent: 1,
      NotApproved: 2,
      Present: 3,
      Holiday: 4,
      Not_Found_Present: 5,
      Worked_on_Holiday: 6,
      Comp_off_Availed: 7,
      Late: 8,
      Hald_Day: 9,
    };
    this.enumUserStatus = {
      Active: true,
      InActive: false,
    };
    this.enumCustomerStatus = {
      Active: true,
      InActive: false,
    };
    this.enumProjectStatus = {
      Open: "1",
    };
    this.enumIssueStage = {
      Open: "1",
      Closed: "2",
    };
    this.enumFeeType = {
      Per_Project: 1,
      Per_Task: 2,
    };

    this.enumSiteUserStatus = [
      { id: true, value: "Active" },
      { id: false, value: "InActive" },
    ];

    this.enumReviewEmployeeStatus = {
      Setup: 1,
      Locked: 2,
      Review: 3,
      Closed: 4,
    };
    this.enumUserRole = {
      SysAdmin: 0,
      Admin: 1,
      Manager: 2,
      Executive: 3,
      HRAdmin: 4,
      Vendor: 5,
      Customer: 6,
    };

    this.dataInputFileTypeId = {
      CustomerLocation: 1,
      TaskLocation: 2,
    };

    this.messageId = {
      Exception: 0,
      ColumnMissed: 9,
      InvalidData: 8,
      DataMissing: 12,
      Mandatory: 11,
      Success: 10,
    };

    this.uploadStatus = {
      UploadPreview: 1,
      ProcessPreview: 2,
      UploadCompleted: 3,
      UploadCancelled: 4,
    };

    this.taskStatus = {
      Created: 1,
      Assigned: 2,
      Inprogress: 3,
      Completed: 4,
      OnHold: 5,
      Cancelled: 6,
      Closed: 7,
    };

    this.IRStatus = {
      Draft: 1,
      Assigned: 2,
      InProgress: 3,
      Completed: 4,
      Locked: 5,
    };

    this.projectType = {
      HWInstallation: 11,
      ProjectSupport: 12,
    };

    this.FileType = {
      IRReport: "1",
      IRImage: "2",
    };

    this.PrjectStage = {
      Planning: 1,
      Implementation: 2,
      Sustance: 3,
      Documentation: 4,
      Closure: 5,
      Closed: 6,
      Handover: 7,
      AMC: 8,
    };

    this.PwerBiMenu = {
      Emqube: 154,
      Swan: 153,
    };

    this.InstallationType = {
      Swan: 1,
      Vendor: 2,
    };

    this.UserType = {
      Internal: 1,
      Vendor: 2,
      Customer: 3,
      Admin: 4,
    };

    this.AttachmentsPath =
      "https://salespro.swansol.net/api/Documents/Attachment/";
  }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/Services/Constants.ts
 **/